export default __webpack_public_path__ + "static/media/pagibig.771dc6cb.svg";